<template>
    <spinner v-if="initialLoading" />

    <div v-else>
        <div class="gutter-b">
            <router-link
                class="btn btn-warning svg-icon-white d-block d-md-inline-block"
                :to="{ name: 'genres' }"
            >
                <ArrowLeftSvg />
                {{ translate("Go Back") }}
            </router-link>
        </div>

        <SubmissionSingle v-if="submission" :submission="submission">
            <template v-slot:tabs-slot>
                <div class="text-center" v-if="is_publishing">
                    {{ translate("Publishing submission") }}...
                </div>
                <div class="text-center" v-else>
                    <router-link
                        class="btn btn-light mr-md-3 mb-4 d-block d-md-inline-block dm-font-bigger-bold"
                        :to="{ name: 'genres' }"
                    >
                        <span class="svg-icon svg-icon-2x m-0 back-form-icon">
                            <AngleLeftSvg />
                        </span>
                        {{ translate("Back to Submission form") }}
                    </router-link>

                    <button
                        class="btn btn-lg btn-success mr-md-3 mb-4 d-block d-md-inline-block dm-font-bigger-bold"
                        @click="publishSubmission()"
                    >
                        {{ translate("Submit your project") }}
                    </button>
                </div>
            </template>
        </SubmissionSingle>
    </div>
</template>

<script>
import { swalLandingMixin } from "@/mixins/swalLandingMixin.js";
import SubmissionSingle from "./partials/SubmissionSingle.vue";
import AngleLeftSvg from "@/svg/AngleLeftSvg.vue";
import ArrowLeftSvg from "@/svg/ArrowLeftSvg.vue";

export default {
    mixins: [swalLandingMixin],

    components: {
        SubmissionSingle,
        AngleLeftSvg,
        ArrowLeftSvg,
    },

    data() {
        return {
            is_publishing: false,
            submission_id: null,
            submission: [],
            is_presentation_dirty: false,
            is_blueprint_newly_created: false,
            initialLoading: false,

            companyName: companyName, // Exists in DOM
        };
    },

    methods: {
        loadSubmissionPreview() {
            var self = this;
            axios
                .get("/api/sw/submissions/" + this.submission_id + "/preview")
                .then(function (response) {
                    self.submission = response.data.submission;
                    self.is_blueprint_newly_created =
                        response.data.is_blueprint_newly_created;
                    self.is_presentation_dirty =
                        response.data.is_presentation_dirty;
                    self.initialLoading = false;
                });
        },

        publishSubmission() {
            var self = this;
            this.is_publishing = true;
            axios
                .patch("/api/sw/submissions/" + this.submission_id + "/publish")
                .then(function (response) {
                    if (self.is_blueprint_newly_created) {
                        self.showSubmissionPublishedAndBlueprintCreatedPopup();
                    } else if (self.is_presentation_dirty) {
                        // this prop is loaded from the controller
                        self.showSaveNewBlueprintPrompt();
                    } else {
                        self.showSubmissionPublishedPopup();
                    }
                });
        },
    },

    mounted() {
        this.initialLoading = true;

        this.submission_id = submissionId; // NB: Must exist in the DOM

        this.loadSubmissionPreview();
    },
};
</script>
